module.exports = __webpack_public_path__ + "img/partial_refunded_seal.956f6483.png";